import React from 'react';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import MigrationPage from '../integrations/exalus/modules/migration';
import LoginPage from '../modules/login';
import PrivacyPage from '../modules/privacy';
import RodoPage from '../modules/rodo';
import SupportPage from '../modules/support';
import TermsPage from '../modules/terms';
import { withRouteWrapper } from '../utils/routes/route-wrapper';
import { ROUTES } from './routes';

export const router = createBrowserRouter([
  {
    path: ROUTES.Terms(),
    element: withRouteWrapper(TermsPage),
  },
  {
    path: ROUTES.Privacy(),
    element: withRouteWrapper(PrivacyPage),
  },
  {
    path: ROUTES.Support(),
    element: withRouteWrapper(SupportPage),
  },
  {
    path: ROUTES.Rodo(),
    element: withRouteWrapper(RodoPage),
  },
  {
    path: ROUTES.Migration(),
    element: withRouteWrapper(MigrationPage),
  },
  {
    path: ROUTES.Root(),
    element: withRouteWrapper(LoginPage),
  },
  {
    path: '*',
    element: <Navigate to={ROUTES.Root()} replace />,
  },
]);

export const UnauthenticatedRouter: React.FC = () => (
  <RouterProvider router={router} future={{ v7_startTransition: false }} />
);
